import Image from 'next/image';

import { Box } from '@mui/system';

import MaintenaceImage from '@public/images/astro-tooling-error.png';

import Text from './text';

const Maintenance = () => {
  return (
    <Box
      sx={{
        marginTop: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        flex: 1,
      }}>
      <Text.Title>We zijn zo terug! 🚧</Text.Title>
      <Text.Body>
        We voeren op dit moment onderhoud uit om jouw ervaring nog beter te maken. Geen zorgen, we
        zijn snel weer online!
      </Text.Body>
      <Text.Body>Kom later terug of neem bij dringende vragen contact met ons op.</Text.Body>
      <Image src={MaintenaceImage} alt='Maintenance illustration' width={500} />
    </Box>
  );
};

export default Maintenance;
